import { ORIGIN } from '#src/config.ts';
import {
  ONBOARDING_MANGOPAY_KYC,
  WALLET,
} from '#src/constants/__generated__/routes.ts';
import { toInternalPath } from '#src/lib/urls.ts';

type LocationParts = { pathname: string; search: string };

const getRedirectTarget = ({ pathname, search }: LocationParts) => {
  const params = new URLSearchParams(search);

  if (pathname === ONBOARDING_MANGOPAY_KYC) {
    return toInternalPath(params.get('redirectUrl'), WALLET);
  }

  params.delete('action');
  const remainingSearch = params.toString();

  return remainingSearch ? `${pathname}?${remainingSearch}` : pathname;
};

export const buildReturnUrl = (location: LocationParts) =>
  `${ORIGIN}${ONBOARDING_MANGOPAY_KYC}?redirectUrl=${encodeURIComponent(getRedirectTarget(location))}`;
